import Header from "@/components/Header";
import { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Handelsbetingelser</h1>
        
        <div className="prose prose-slate max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Generelt</h2>
            <p className="text-muted-foreground">
              Disse handelsbetingelser gælder for brug af SharePark-platformen, der forbinder 
              personer, som ønsker at leje en parkeringsplads (lejere) med personer, som ønsker 
              at udleje deres parkeringsplads (udlejere).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Kontooprettelse</h2>
            <p className="text-muted-foreground mb-4">
              For at bruge SharePark skal du:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Være mindst 18 år</li>
              <li>Oprette en konto med korrekte oplysninger</li>
              <li>Holde dine loginoplysninger fortrolige</li>
              <li>Acceptere vores privatlivspolitik</li>
              <li>Overholde gældende lovgivning</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. For udlejere</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-4">3.1 Oprettelse af annonce</h3>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Du skal have ret til at udleje parkeringspladsen</li>
              <li>Alle oplysninger skal være korrekte og opdaterede</li>
              <li>Fotos skal være autentiske og opdaterede</li>
              <li>Priser skal være klare og inkludere alle gebyrer</li>
              <li>Annoncer godkendes af SharePark før publicering</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-4">3.2 Forpligtelser</h3>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Overholde aftaler med lejere</li>
              <li>Sikre at parkeringspladsen er tilgængelig som beskrevet</li>
              <li>Reagere hurtigt på bookingforespørgsler</li>
              <li>Overholde relevante p-love og -regler</li>
              <li>Betale skat af indtægter fra udlejning</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-4">3.3 Udbetaling</h3>
            <p className="text-muted-foreground">
              Udbetaling sker via Stripe Connect. SharePark trækker et servicegebyr på 15% af 
              lejeprisen. Udbetalinger behandles efter bookingperiodens afslutning.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. For lejere</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-4">4.1 Booking</h3>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Alle bookinger er bindende</li>
              <li>Betaling sker via Stripe</li>
              <li>Du modtager bookingbekræftelse via email</li>
              <li>Kontaktoplysninger deles efter bekræftelse</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-4">4.2 Brug af parkeringsplads</h3>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Overhold udlejers regler og instruktioner</li>
              <li>Parker kun det aftalte køretøj</li>
              <li>Forlad pladsen i samme stand som ved ankomst</li>
              <li>Overskrid ikke den aftalte tid</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-4">4.3 Ansvar</h3>
            <p className="text-muted-foreground">
              Du er ansvarlig for skader på parkeringspladsen eller omkringliggende område 
              forårsaget under din leje. SharePark anbefaler at have relevant forsikring.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Afbestilling og refundering</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-4">5.1 Fleksibel politik</h3>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Afbestilling mere end 24 timer før: 100% refusion</li>
              <li>Afbestilling 12-24 timer før: 50% refusion</li>
              <li>Afbestilling mindre end 12 timer før: Ingen refusion</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-4">5.2 Moderat politik</h3>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Afbestilling mere end 5 dage før: 100% refusion</li>
              <li>Afbestilling 2-5 dage før: 50% refusion</li>
              <li>Afbestilling mindre end 2 dage før: Ingen refusion</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-4">5.3 Streng politik</h3>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Afbestilling mere end 7 dage før: 50% refusion</li>
              <li>Afbestilling mindre end 7 dage før: Ingen refusion</li>
            </ul>

            <p className="text-muted-foreground mt-4">
              Refusioner behandles inden for 5-10 hverdage.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. ShareParks rolle</h2>
            <p className="text-muted-foreground mb-4">
              SharePark er en formidlingsplatform og deltager ikke direkte i leje-aftaler. Vi:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Faciliterer kontakt mellem udlejere og lejere</li>
              <li>Håndterer betalinger og udbetalinger</li>
              <li>Modererer annoncer og brugere</li>
              <li>Tilbyder kundesupport</li>
              <li>Påser overholdelse af vilkår</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">7. Ansvarsbegrænsning</h2>
            <p className="text-muted-foreground">
              SharePark er ikke ansvarlig for:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Skader på køretøjer under parkering</li>
              <li>Tyveri eller hærværk</li>
              <li>Manglende overholdelse af aftaler mellem parter</li>
              <li>Fejl eller unøjagtigheder i annoncer</li>
              <li>Tab som følge af platformens utilgængelighed</li>
            </ul>
            <p className="text-muted-foreground mt-4">
              Vi anbefaler kraftigt at have relevant forsikring.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">8. Tvister</h2>
            <p className="text-muted-foreground">
              Ved uenigheder mellem udlejer og lejer opfordrer vi til at løse det indbyrdes. 
              Hvis dette ikke lykkes, kan du oprette en tvist i systemet, hvor SharePark kan 
              facilitere en løsning. I yderste konsekvens kan tvister indbringes for de 
              almindelige domstole i Danmark.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">9. Suspendering og lukning</h2>
            <p className="text-muted-foreground">
              SharePark forbeholder sig ret til at suspendere eller lukke konti ved:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Brud på disse vilkår</li>
              <li>Mistanke om bedrageri</li>
              <li>Gentagne klager fra andre brugere</li>
              <li>Ulovlig aktivitet</li>
              <li>Misbrug af platformen</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">10. Ændringer</h2>
            <p className="text-muted-foreground">
              Vi kan opdatere disse vilkår fra tid til anden. Væsentlige ændringer vil blive 
              meddelt via email. Fortsat brug af platformen efter ændringer udgør accept af 
              de nye vilkår.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">11. Gældende ret</h2>
            <p className="text-muted-foreground">
              Disse vilkår er underlagt dansk ret. Eventuelle tvister skal afgøres ved de 
              danske domstole.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">12. Kontakt</h2>
            <p className="text-muted-foreground">
              Har du spørgsmål til vores vilkår, kan du kontakte os på:<br />
              Email: askyum@hotmail.com<br />
              Telefon: [Indsæt telefonnummer]
            </p>
          </section>

          <p className="text-sm text-muted-foreground mt-8">
            Sidst opdateret: {new Date().toLocaleDateString('da-DK')}
          </p>
        </div>
      </main>
    </div>
  );
}
